<template>
  <div
    :class="['w-100 border-bottom', { 'sticky-top': isMobile }]"
    id="navbar-top-container"
  >
    <b-navbar toggleable="md" type="light" variant="white">
      <div
        :class="[
          'd-flex align-items-center w-100 justify-content-center',
          { container: !isMobile }
        ]"
      >
        <b-navbar-brand href="#" class="text-center flex-grow-0 mr-0">
          <NavBrand />
        </b-navbar-brand>
      </div>
    </b-navbar>
    <CartPromptModal />
  </div>
</template>

<script>
import { mapState } from "vuex";
import NavBrand from "@/components/layout/NavBrand";
import CartPromptModal from "@/components/cart/CartPromptModal";

export default {
  name: "Navbar",
  components: {
    NavBrand,
    CartPromptModal
  },
  data() {
    return {
      isMobileNaviconOpen: false,
      isMobile: false
    };
  },
  watch: {
    isMobileNaviconOpen(open) {
      if (open) {
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = null;
      }
    },
    $route() {
      this.$nextTick(() => {
        if (this.isMobileNaviconOpen) {
          this.isMobileNaviconOpen = false;
        }
      });
    }
  },
  mounted() {
    // Set Navbar Icon on Sidebar Trigger
    this.$root.$on("bv::toggle::collapse", el => {
      if (el === "mobile-menu-sidebar") {
        this.isMobileNaviconOpen = !this.isMobileNaviconOpen;
      }
    });
    this.$root.$on("mobilePlaceSelected", () => {
      this.$refs.mobileNavIcon.click();
    });
    this.$root.$on("toggleMobileNavIcon", route => {
      const path = this.$route.path.split("/").pop();
      const isSamePage =
        path !== route
          ? (route === "orders" && path === "upcoming") ||
            (route === "" && path === "estore")
          : path === route;
      if (!isSamePage) {
        this.isMobileNaviconOpen = !this.isMobileNaviconOpen;
      } else {
        this.$refs.mobileNavIcon.click();
      }
    });
    window.addEventListener("resize", () => {
      // close mobile menu sidebar if not Mobile Size
      this.isMobile = window.innerWidth < 845;
      if (
        !this.isMobile &&
        this.isMobileNaviconOpen &&
        this.$refs.mobileNavIcon !== undefined
      ) {
        this.$refs.mobileNavIcon.click();
      }
    });
  },
  beforeDestroy() {
    document.body.style.overflowY = null;
    this.$root.$off("toggleMobileNavIcon");
  },
  created() {
    // close mobile menu sidebar if not Mobile Size
    this.isMobile = window.innerWidth < 1092;
    this.$nextTick(() => {
      if (!this.isMobile && this.isMobileNaviconOpen) {
        this.$refs.mobileNavIcon.click();
      }
    });
  },
  computed: {
    ...mapState("merchant", {
      subdomain: state => state.subdomain
    })
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/layout/mobile-nav.scss";
#navbar-top-container {
  width: calc(100% - 1px) !important;
}
</style>

<style lang="scss">
.mobile-map-width {
  width: 100vw !important;
}
.mobile-map-height {
  height: calc(100vh - 15px) !important;
}
</style>
